"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadScript = void 0;
/**
 * Promise-based script loader
 */
var loadScript = function (src) {
    return new Promise(function (resolve, reject) {
        var element = document.createElement('script');
        element.src = src;
        element.type = 'text/javascript';
        element.async = true;
        var removeScript = function () {
            document.head.removeChild(element);
        };
        element.onload = function () {
            resolve();
            removeScript();
        };
        element.onerror = function () {
            /** The actual script loading error event doesn't provide useful information */
            reject(new Error('script loading failed'));
            removeScript();
        };
        document.head.appendChild(element);
    });
};
exports.loadScript = loadScript;
//# sourceMappingURL=loadScript.js.map